/**
 * SDK 嵌入外部页面时，axios 不能再用构建时的 VITE_APP_BASE_API='/'（会打到外部站点导致 404）。
 * 通过 setSdkApiConfig / context.apiBaseUrl 在挂载前指定真实后端地址。
 */

export interface SdkApiConfig {
  /** axios baseURL，如 https://fh.zxhkuav.cn 或外部项目代理前缀 /dev-api */
  baseApi?: string
  /** 对应 VITE_APP_BASE_URL，部分识别流地址会用到 */
  baseUrl?: string
  /** 对应 VITE_APP_DETECT_IMAGE_API */
  detectImageApi?: string
}

let runtimeConfig: SdkApiConfig = {}

export function setSdkApiConfig (cfg: SdkApiConfig): void {
  runtimeConfig = { ...runtimeConfig, ...cfg }
}

export function clearSdkApiConfig (): void {
  runtimeConfig = {}
}

export function getSdkApiBase (): string | undefined {
  const v = runtimeConfig.baseApi?.trim()
  return v || undefined
}

export function resolveAppBaseApi (): string {
  return getSdkApiBase() ?? import.meta.env.VITE_APP_BASE_API ?? '/'
}

export function resolveAppBaseUrl (): string {
  const v = runtimeConfig.baseUrl?.trim()
  return v || import.meta.env.VITE_APP_BASE_URL || ''
}

export function resolveDetectImageApi (): string {
  const v = runtimeConfig.detectImageApi?.trim()
  return v || import.meta.env.VITE_APP_DETECT_IMAGE_API || ''
}
